import React from "react";
import "./WebsiteName.css";
const WebsiteName = () => {
  return (
    <>
        <h1 id="main_heading">
          ORANGE TREE EDUCATION
        </h1>
    </>
  );
};
export default WebsiteName;
